import { Box, TextField } from "@mui/material";
import ReactInputMask, { Props } from "react-input-mask";
import { DEFAULT_FONTSIZE, FILED_LABEL_FONTSIZE } from "../utils/utils";
import Text from "./Text";
import Flex from "./Flex";
import { useFieldLock } from "./ReadOnlyFields";

type CustomMaskInputProps = {
  value?: string | ReadonlyArray<string> | number | undefined;
  mask: string | Array<string | RegExp>;
  label?: string;
  error?: string | boolean;
  onChange?: (e: any) => void;
  maskChar?: string | null | undefined;
} & Props;

/**
 * To handle the mask input
 *
 * @param {CustomMaskInputProps} Props
 *
 * @author rajkumar rathod
 */
const MaskInput = ({
  value,
  mask,
  maskChar = "",
  onChange,
  error,
  label,
  disabled,
  readOnly,
  ...others
}: CustomMaskInputProps) => {
  const lock = useFieldLock(disabled || readOnly);

  return (
    <Box>
      {/* show label and required start for field */}
      {/* <Typography mb={"10px"} sx={DEFAULT_FONTSIZE}> */}
      {/* {label}
        {others?.required && (
          <Typography fontSize={"13px"} component={"span"} color={"error"}>
            {` *`}
          </Typography>
        )} */}
      {/* </Typography> */}
      <ReactInputMask
        // maskChar replace with removed-char
        maskChar={maskChar}
        // for style mui component render internally
        children={
          (() => (
            <TextField
              InputLabelProps={{ shrink: true }}
              label={inputLabel(label, others?.required)}
              disabled={lock.disabled}
              InputProps={{ readOnly: lock.readOnly }}
              sx={{ "& .MuiInputBase-input": DEFAULT_FONTSIZE }}
              name={others?.name}
              onBlur={others?.onBlur}
              fullWidth
              error={!!error}
              variant="outlined"
              placeholder={others?.placeholder}
            />
          )) as any
        }
        {...others}
        // Resolved rather than forwarded: react-input-mask passes its own props
        // down to the rendered input, so an unresolved `disabled` would win
        // over the TextField's.
        disabled={lock.disabled}
        readOnly={lock.readOnly}
        mask={mask}
        value={value}
        onChange={onChange}
      />

      {/* show error message */}
      {!!error && (
        <Text fontSize={"13px"} variant="caption" color="error">
          {error}
        </Text>
      )}
    </Box>
  );
};

export default MaskInput;

export const inputLabel = (label?: string, required?: boolean) =>
  label ? (
    <Flex gap={0.4}>
      <Text fontSize={FILED_LABEL_FONTSIZE}>{label}</Text>
      {!!required && (
        <Text fontSize={"13px"} component={"span"} color={"error"}>
          {` *`}
        </Text>
      )}
    </Flex>
  ) : undefined;
